import Vue from 'vue'
import {
  extend,
  localize,
  configure,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en.json'
import hu from 'vee-validate/dist/locale/hu.json'
import i18n from '../i18n'
import moment from 'moment'

// Install English and Arabic locales.
localize({
  en: {
    messages: en.messages,
    names: {
      plane_class: 'Plane Class',
    },
  },
  hu: {
    messages: hu.messages,
    names: {
      plane_class: 'Géposztály',
    },
  },
})

configure({
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`fields.${field}`)
    return i18n.t(`validation.${values._rule_}`, values)
  },
})

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule])
})

Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)

localize('hu')

extend('positive', value => {
  if (value >= 0) {
    return true
  }
  return 'This value must be a positive number'
})

extend('date', value => {
  const date = moment(value, 'YYYY-MM-DD', true)
  // console.log('Dátum validálás')
  if (date.isValid()) {
    return true
  }
  return i18n.t('this_value_is_not_valid_date')
})

extend('time', value => {
  switch (value.length) {
    case 1:
      value = '00:0' + value
      break
    case 2:
      value = '00:' + value
      break
    case 3:
      value = ['0', value.slice(0, 1), ':', value.slice(1)].join('')
      break
    case 4:
      value = [value.slice(0, 2), ':', value.slice(2)].join('')
      break
  }
  const time = moment(value, 'HH:mm', true)
  // console.log('Idő validálás')
  if (time.isValid()) {
    return true
  }
  return i18n.t('this_value_is_not_valid_time')
})

extend('datetime', value => {
  const date = moment(value, 'YYYY-MM-DD HH:mm', true)
  // console.log('Dátum validálás')
  if (date.isValid()) {
    return true
  }
  return i18n.t('this_value_is_not_valid_datetime')
})
